
import {Component, Mixins, Watch} from 'vue-property-decorator';
import {authentication, permission} from "@pazion/pazion-core/src/store";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";

@Component({
  components: {PazToast}
})
export default class PazionErrorPage extends Mixins(PermissionService) {
  $refs!: {
    toast: PazToast
  }

  public message: string = '';

  async mounted() {

    // this.$refs.toast.show({
    //   message: "Error message: " + globalStore.message ,
    //   icon: 'mdi-close-circle',
    //   color: 'red'
    // })

  }

}
